import { useState } from "react";
import Box from "../components/Box";
import AlertBox from "../components/AlertBox";
import MainLayout from "../components/layouts/MainLayout";
import Pagination from "../components/Pagination";
import { useControlPermission } from "../utils/ActionPermissionUtils";
import { useRegistrationPartnerInfraHooks } from "../utils/project/PartnerUtils";
import { useGroupListHooks } from "../utils/ProjectsUtilHooks";
import ModalDownloadRegistrationPartner from "../components/registration/ModalDownloadRegistrationPartner";

export default function RegistrationsPartnerPage() {
  const { hasAccess } = useControlPermission();
  const { projects } = useGroupListHooks();

  const [formFilter, setFormFilter] = useState({
    q: "",
    project_id: "",
  });
  const [filter, setFilter] = useState({
    q: "",
    project_id: "",
    page: 1,
    page_size: 20,
  });

  const [alert, setAlert] = useState({ show: false, message: "", type: "" });
  const [modal, setModal] = useState(null);

  const { registrations, errorMsg, meta, loading, getAllRegistrations } =
    useRegistrationPartnerInfraHooks({
      filter,
    });

  function applyFilter() {
    let form_filter = {
      ...filter,
      ...formFilter,
      page: 1,
    };
    setFilter(form_filter);
  }

  const resetFilter = () => {
    setFormFilter({
      q: "",
      project_id: "",
    });
    setFilter({
      q: "",
      project_id: "",
      page: 1,
      page_size: 20,
    });
  };

  const changeFilter = (name, value) => {
    setFormFilter({ ...formFilter, [name]: value });
  };

  const onSuccess = (message) => {
    getAllRegistrations(filter);
    setAlert({ show: true, message: message, type: "success" });
  };

  const gotoPage = (page) => {
    setFilter({ ...filter, page: page });
  };

  return (
    <MainLayout resource_key="partner-infrastructure">
      <div className="container-fluid">
        <div className="row mb-4">
          <div className="col">
            <h1 className="h3 mb-0 text-gray-800">Report Pendaftaran Partner Infrastruktur</h1>
          </div>
          <div className="col-auto">
            {hasAccess("export-partner-infrastructure-registration") && (
              <button className="btn btn-primary" onClick={() => setModal("download")}>
                <i className="fas fa-download"></i> Unduh Data Pendaftar
              </button>
            )}
          </div>
        </div>

        <Box title={`Daftar Pendaftaran (Total Data: ${meta.count})`} loading={loading}>
          <div className="mb-4">
            <div className="row">
              <div className="col-12 col-md-2">
                <div className="form-group">
                  <label htmlFor="query_search">Pencarian Nomor</label>
                  <input
                    type="text"
                    name="query_search"
                    value={formFilter.q}
                    placeholder="Nama Pelanggan/No. Pelanggan"
                    onChange={(event) => changeFilter("q", event.target.value)}
                    className="form-control"
                    id="query_search"
                  />
                </div>
              </div>
              <div className="col-12 col-md-2">
                <label htmlFor="projectFilter">Grup/Project</label>
                <select
                  className="form-control"
                  id="projectFilter"
                  value={formFilter.project_id}
                  onChange={(event) => changeFilter("project_id", event.target.value)}
                >
                  <option value="">SEMUA</option>
                  {projects.map((project, index) => (
                    <option value={project.id} key={index}>
                      {project.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-auto">
                <button
                  className="btn btn-primary"
                  onClick={() => applyFilter()}
                  style={{ marginTop: "32px" }}
                >
                  Filter
                </button>
                <button
                  className="btn btn-default"
                  onClick={() => resetFilter()}
                  style={{ marginTop: "32px" }}
                >
                  Reset
                </button>
              </div>
            </div>
          </div>
          {errorMsg && <div className="alert alert-danger">{errorMsg}</div>}
          <AlertBox {...alert} setAlert={setAlert} />

          <div style={{ overflowX: "auto" }}>
            <table className="table table-hover table-bordered table-striped">
              <thead>
                <tr>
                  <th>No. Registrasi</th>
                  <th>Nama</th>
                  <th>Status</th>
                  <th>Paket</th>
                  <th>Project</th>
                  <th>Provisioning ID</th>
                  <th>Provisioning Service ID</th>
                </tr>
              </thead>
              <tbody>
                {registrations.length === 0 && (
                  <tr>
                    <td colSpan={11} className="text-center">
                      Tidak ada data
                    </td>
                  </tr>
                )}

                {registrations.map((registration) => (
                  <tr key={registration.id}>
                    <td>{registration.registration_number}</td>
                    <td>{registration.name}</td>
                    <td>PENJADWALAN PEMASANGAN</td>
                    <td>{registration.internet_package?.name || "-"}</td>
                    <td>{registration.project?.name || "-"}</td>
                    <td>{registration.provisioning?.partner_provisioning_id}</td>
                    <td>{registration.provisioning?.partner_service_id}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {meta.count > meta.page_size && (
            <Pagination
              totalpage={Math.ceil(meta.count / meta.page_size)}
              selectedpage={meta.page}
              clickpage={(page) => gotoPage(page)}
              next={() => gotoPage(meta.page + 1)}
              prev={() => gotoPage(meta.page - 1)}
            />
          )}
        </Box>
      </div>
      <ModalDownloadRegistrationPartner
        show={modal === "download"}
        onClose={() => setModal(null)}
        onSuccess={onSuccess}
      />
    </MainLayout>
  );
}
